import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { api } from '../utils/api';

export default function Profile() {
  const { user, token, refreshUser } = useAuth();
  const [cur, setCur] = useState('');
  const [nw, setNw] = useState('');
  const [conf, setConf] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (nw !== conf) { setError('Las contraseñas no coinciden'); return; }
    if (nw.length < 8) { setError('La contraseña debe tener al menos 8 caracteres'); return; }
    setError(''); setLoading(true);
    try {
      await api.changePassword(token, cur, nw);
      setSuccess('Contraseña actualizada correctamente');
      setCur(''); setNw(''); setConf('');
      await refreshUser();
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="main-content page-enter">
      <div style={{ marginBottom: '1.8rem' }}>
        <div className="section-label">Tu cuenta</div>
        <h1>Perfil</h1>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.2rem', maxWidth: 720 }}>
        <div className="card">
          <div className="section-label" style={{ marginBottom: '1rem' }}>Información</div>
          {[
            ['Nombre', user?.familyName || user?.displayName || user?.nombre || '—'],
            ['Email', user?.email],
            ['Rol', user?.role === 'admin' ? '⚔ Administrador' : '◈ Familia'],
          ].map(([l, v]) => (
            <div key={l} style={{ marginBottom: '.8rem' }}>
              <div style={{ fontFamily: "'Fraunces',serif", fontSize: '.58rem', fontWeight: 700, letterSpacing: '.15em', color: 'var(--mid)', textTransform: 'uppercase', marginBottom: '.15rem' }}>{l}</div>
              <div style={{ color: l === 'Rol' ? 'var(--sage)' : undefined, fontFamily: l === 'Rol' ? "'Fraunces',serif" : undefined, fontWeight: l === 'Rol' ? 700 : undefined }}>{v}</div>
            </div>
          ))}
        </div>

        <div className="card">
          <div className="section-label" style={{ marginBottom: '1rem' }}>Cambiar contraseña</div>
          {error && <div className="alert alert-error"><span>⚠</span> {error}</div>}
          {success && <div className="alert alert-success"><span>🌿</span> {success}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Contraseña actual</label>
              <input className="form-input" type="password" value={cur} onChange={e => setCur(e.target.value)} required />
            </div>
            <div className="form-group">
              <label className="form-label">Nueva contraseña</label>
              <input className="form-input" type="password" value={nw} onChange={e => setNw(e.target.value)} required placeholder="Mínimo 8 caracteres" />
            </div>
            <div className="form-group">
              <label className="form-label">Confirmar contraseña</label>
              <input className="form-input" type="password" value={conf} onChange={e => setConf(e.target.value)} required />
            </div>
            <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
              {loading ? <><span className="spinner" /> Guardando...</> : 'Actualizar contraseña'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
